import { Link } from 'react-router-dom';
import { ouvrirPreferencesCookies } from '../CookieBanner/CookieBanner';
import './Footer.css';

export default function Footer() {
  const annee = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer__inner">

        {/* Brand */}
        <div className="footer__brand">
          <p className="footer__logo-top">Les Bazars</p>
          <p className="footer__logo-bottom">de Keassa</p>
          <p className="footer__tagline">Mode & Élégance à Paris</p>
          <div className="footer__socials">
            <a href="https://tiktok.com/@lesbazarsdekeassa" target="_blank" rel="noreferrer"
               className="footer__social" aria-label="Notre TikTok">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.65a8.19 8.19 0 0 0 4.79 1.52V6.7a4.85 4.85 0 0 1-1.02-.01z"/>
              </svg>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer"
               className="footer__social" aria-label="Notre Instagram">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <circle cx="12" cy="12" r="5"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Navigation */}
        <div className="footer__col">
          <h3 className="footer__titre">Catalogue</h3>
          <ul className="footer__links">
            <li><Link to="/catalogue/bijoux">Bijoux</Link></li>
            <li><Link to="/catalogue/perruques">Perruques</Link></li>
            <li><Link to="/catalogue">Tout voir</Link></li>
          </ul>
        </div>

        <div className="footer__col">
          <h3 className="footer__titre">Mon compte</h3>
          <ul className="footer__links">
            <li><Link to="/connexion">Se connecter</Link></li>
            <li><Link to="/inscription">Créer un compte</Link></li>
            <li><Link to="/commandes">Mes commandes</Link></li>
          </ul>
        </div>

        <div className="footer__col">
          <h3 className="footer__titre">Informations</h3>
          <ul className="footer__links">
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/suivi">Suivre ma commande</Link></li>
            <li><Link to="/mentions-legales">Mentions légales</Link></li>
            <li><Link to="/cgv">CGV</Link></li>
            <li><Link to="/politique-confidentialite">Confidentialité</Link></li>
            <li>
              {/* Le consentement doit pouvoir être retiré aussi simplement
                  qu'il a été donné : ce lien rouvre la fenêtre de choix. */}
              <button type="button" className="footer__link-btn" onClick={ouvrirPreferencesCookies}>
                Gérer mes préférences
              </button>
            </li>
          </ul>
        </div>

      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p>© {annee} Les Bazars de Keassa — Tous droits réservés</p>
          <p className="footer__payment">
            <span>Paiement sécurisé</span>
            <span className="footer__stripe">⚡ Stripe</span>
          </p>
        </div>
      </div>
    </footer>
  );
}